import React, { useEffect, useState } from 'react';
import './CarsStyle.css';
import InputField from '../components/InputField';
import { emCar } from '../model/emCars';
import MemberList from '../components/MemberList';
import { useNavigate } from 'react-router-dom';
import { AiFillDelete} from "react-icons/ai";

interface Props{
    loggedState: number;
    loggedID: String;
}

const Cars = ({loggedState,loggedID}:Props) => {
  const [emCars,setEmCars] = useState<emCar[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const navigate = useNavigate();
    
    const back = () => {
        navigate("/MainPage");
    };
    
  useEffect(() => {
    ReadCars(-2,loggedID);
  }, []);

  const filteredCars = emCars.filter(car => 
    car.name.toLowerCase().includes(searchTerm.toLowerCase()) // Filter nach Name
  );

  const ReadCars = async (emID:number,loggedID:String) => {
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadCars.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          emID,
          loggedID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        console.log('Cars vorhanden:', data);
        setEmCars(data);
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen der Cars:', response.statusText);
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }
};
  
  const handleCheckboxChange = async (carID:String, column:String, value:String) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateCar.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              //Einsatz => em_Einsätze
              carID,
              column,
              value,
            }),
          });

          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            if(data.status === 'success'){
              ReadCars(-2,loggedID);
            }
            else{
              alert("Fahrzeug konnte nicht aktualisiert werden");
            }
              
          } else {
            const data = await response.json();
            alert("Fahrzeug konnte nicht aktualisiert werden");
          }
        } catch (error) {
          console.error('Fehler beim Request:', error);
        }   
  };

  const updateName = (id:number, field:string, value:string) => {
    setEmCars((prevCars) =>
      prevCars.map((car) =>
        car.ID === id
          ? { ...car, [field]: value } // Update das Feld (activeMember oder agt)
          : car
      )
    );
  };

  const handleNameChange = async (carID:String, value:String) => {
    const column = 'name'
    try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateCar.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          //Einsatz => em_Einsätze 
          carID,
          column,
          value,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if(data.status === 'success'){
          ReadCars(-2,loggedID);
        }
        else{
          alert("Fahrzeug konnte nicht aktualisiert werden");
        }
          
      } else {
        const data = await response.json();
        alert("Fahrzeug konnte nicht aktualisiert werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }   
  };

  const deleteCar = async (ID:number) => {
    try {
        const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/DeleteCar.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ID,
          }),
        });
  
        if (response.ok) {
          const data = await response.json();
          // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
          if(data.status === 'success'){
            alert("Fahrzeug wurde gelöscht");
            ReadCars(-2,loggedID)
          }
          else{
            alert("Fahrzeug konnte gelöscht werden werden");
          }
            
        } else {
          const data = await response.json();
          console.error('Fehler beim lesen des Einsatz:', response.statusText);
          alert("Fahrzeug konnte nicht aktualisiert werden");
        }
      } catch (error) {
        console.error('Fehler beim Request:', error);
      }   

};

const carAdd = async (loggedID:String) => {
  try {
      const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/AddCar.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          loggedID,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
        if(data.status === 'success'){
          alert("Fahrzeug wurde angelegt");
          ReadCars(-2,loggedID)
        }
        else{
          alert("Fahrzeug konnte nicht angelegt werden");
        }
          
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("Fahrzeug konnte nicht angelegt werden");
      }
    } catch (error) {
      console.error('Fehler beim Request:', error);
    }   

};

const AddCar = () => {
  carAdd(loggedID)
  
};

const DeleteCar = (id:number) => {
  deleteCar(id)
};

  return (
    <div className="App" style={{ visibility: loggedState === 0 ? 'hidden' : 'visible' }}>
      <div className="search-box-container">
            <div className="header">
                <h2>Fahrzeug-Verwaltung</h2>
                <button className="new-button" onClick={() => AddCar()}>Neues Fahrzeug</button>
            </div>
            <div className="search-box">
                <label htmlFor="search">Suche:</label>
                <input 
                  type="text" 
                  id="search"  
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)} // Überwachen der Eingabe
                />
            </div>
        </div>


      <table className="table">
        <thead className="table-header">
        <tr>
          <th className="col-1">Name</th>
          <th className="col-2"></th>
        </tr>
      </thead>
      <tbody>
        {filteredCars.map((row) => (
          <tr key={row.ID}>
              <td className="col-1">
                <input
                  type="text"
                  value={row.name}
                  onChange={(e) => updateName(row.ID,'name', e.target.value)}
                  onBlur={(e) => handleNameChange(String(row.ID), String(e.target.value))} // Aktualisiere den Namen
                />
              </td>
              <td className="col-2">
                <span className='icon' onClick={()=> DeleteCar(row.ID)}>
                    <AiFillDelete></AiFillDelete>
                </span>
              </td>
          </tr>
        ))}
      </tbody>
    </table>
      

    </div>
  );
}

export default Cars;
